let accessToken: string | null = null;
let generation = 0;
const hintKey = "admin-session-present";

export const getAccessToken = (): string | null => accessToken;
export const getSessionGeneration = (): number => generation;

export const hasSessionHint = (): boolean => {
  try {
    // Migrate the old session without retaining its credential in browser storage.
    if (localStorage.getItem("token")) {
      localStorage.setItem(hintKey, "1");
      localStorage.removeItem("token");
    }
    return localStorage.getItem(hintKey) === "1";
  } catch {
    return false;
  }
};

export const setAccessToken = (token: string): void => {
  accessToken = token;
  try {
    localStorage.removeItem("token");
    localStorage.setItem(hintKey, "1");
  } catch {}
};

export const clearSession = (): void => {
  accessToken = null;
  generation += 1;
  try {
    localStorage.removeItem("token");
    localStorage.removeItem(hintKey);
  } catch {}
};
